const menuMoreBtns = Array.from(document.querySelectorAll('.js-menu__more'));
const menuDropDowns = Array.from(document.querySelectorAll('.js-menu__dropdown'));

menuMoreBtns.forEach((menuMoreBtn, index) => {
	menuMoreBtn.addEventListener('click', () => {
		menuMoreBtns[index].classList.toggle('active');
		menuDropDowns[index].classList.toggle('active');
	});
});
